import { render, staticRenderFns } from "./BoardEmptySearchDefaultLayout.vue?vue&type=template&id=797d4f58&scoped=true&"
import script from "./BoardEmptySearchDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BoardEmptySearchDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d4f58",
  null
  
)

export default component.exports